import React, { useEffect, useState } from "react";
import FileUpload from "./FileUpload";
import TransactionsTable from "./TransactionsTable";
import "./App.css";
import axios from 'axios';
import TrialBanner from "./TrialBanner";
import SessionManager from "./SessionManager";
import Swal from "sweetalert2";
import ConsolidateExport from "./ConsolidateExport";

import InvoicePreview from "./InvoicePreview";
const API_BASE_URL = "https://bank-converter-app-3.onrender.com";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentDocumentId, setCurrentDocumentId] = useState(null);
  const [activeMenu, setActiveMenu] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [uploadsHistory, setUploadsHistory] = useState([]);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [exportCount, setExportCount] = useState(0);
  const [message, setMessage] = useState("");
  const [isRestricted, setIsRestricted] = useState(false);

  const [authToken, setAuthToken] = useState(localStorage.getItem("token") || "");
  const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail") || "");
  const [userName, setUserName] = useState(localStorage.getItem("userName") || "");
  const [showDeviceLimitModal, setShowDeviceLimitModal] = useState(false);
  const [deviceLimitMessage, setDeviceLimitMessage] = useState("");
    const [currentDocumentType, setCurrentDocumentType] = useState(null);
    const [invoiceData, setInvoiceData] = useState(null);

  const [isSigningUp, setIsSigningUp] = useState(false);
  const [signupMessage, setSignupMessage] = useState("");
  const [credentials, setCredentials] = useState({
    email: "",
    password: ""
  });
  const [userDocuments, setUserDocuments] = useState([]);

  const [signupCredentials, setSignupCredentials] = useState({
    username: "",
    email: "",
    password: ""
  });
  const token = localStorage.getItem("token");

  // Settings Tabs
  const [activeSettingsTab, setActiveSettingsTab] = useState("general");

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  const getUserDisplayName = () => {
    if (userName) return userName;
    if (userEmail) {
      let name = userEmail.split("@")[0];
      name = name.replace(/\d+/g, '');
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
    return "User";
  };
  useEffect(() => {
  if (activeMenu === "consolidate" && authToken) {
    fetchDocumentHistory(); // ✅ Re-fetch when opening consolidate page
  }
}, [activeMenu, authToken]);
 const fetchDocumentHistory = async () => {
  if (!authToken) return;
  setIsLoading(true);
  try {
    // ✅ Fetch bank statements
    const docsResponse = await axios.get(`${API_BASE_URL}/my-documents`, {
      headers: { Authorization: `Bearer ${authToken}` },
    });

    // ✅ Fetch invoices
    const invoicesResponse = await axios.get(`${API_BASE_URL}/my-invoices`, {
      headers: { Authorization: `Bearer ${authToken}` },
    });

    // ✅ Add document_type to each item
    const bankStatements = (docsResponse.data || []).map(doc => ({
      ...doc,
      document_type: "bank_statement"
    }));

    const invoices = (invoicesResponse.data || []).map(inv => ({
      ...inv,
      document_type: "invoice"
    }));

    // ✅ Combine both arrays
    const allDocuments = [...bankStatements, ...invoices];

    setDocumentHistory(allDocuments);
  } catch (error) {
    console.error("Failed to fetch history:", error);
  } finally {
    setIsLoading(false);
  }
};

  // Load document history when user logs in

  const getInitial = () => {
    const name = getUserDisplayName();
    return name.charAt(0).toUpperCase();
      };
    useEffect(() => {
      if (window.location.search === "?") {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleSignupChange = (e) => {
    const { name, value } = e.target;
    setSignupCredentials({ ...signupCredentials, [name]: value });
  };
  // --- SIGNUP ---
  const handleSignup = async (e) => {
    e.preventDefault();
    setSignupMessage("Signing up...");
    try {
      const res = await fetch("https://bank-converter-app-3.onrender.com/signup", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(signupCredentials),
      });
      const data = await res.json();
      if (res.ok) {
        Swal.fire({
          icon: "success",
          title: "Account Created!",
          text: "Please log in to continue.",
        });
        setIsSigningUp(false);
        setSignupCredentials({ username: "", email: "", password: "" });
      } else {
        Swal.fire({
          icon: "error",
          title: "Signup Failed",
          text: data.detail || "Could not create account. Try again.",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: err.message,
      });
    }
  };

 // --- LOGIN ---
const handleLogin = async (e) => {
  e.preventDefault();
  setMessage("");

  try {
    const res = await fetch("https://bank-converter-app-3.onrender.com/login", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(credentials),
    });

    const data = await res.json();

    // ✅ SUCCESSFUL LOGIN
    if (res.ok) {
      // --- Store session info ---
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("userEmail", credentials.email);
      if (data.username) localStorage.setItem("userName", data.username);

      setAuthToken(data.access_token);
      setIsLoggedIn(true);
      setUserEmail(credentials.email);
      setUserName(data.username || "");

      // ✅ Handle restriction flag from backend
      if (data.restricted) {
        setIsRestricted(true); // You must declare: const [isRestricted, setIsRestricted] = useState(false);

        Swal.fire({
          icon: "warning",
          title: "Access Restricted",
          text: "Your trial has expired. Upgrade to Premium to continue.",
          showCancelButton: true,
          confirmButtonText: "Upgrade Now",
          cancelButtonText: "Later",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "#/settings?tab=billing";
          }
        });
      } else {
        setIsRestricted(false);
        Swal.fire({
          icon: "success",
          title: "Welcome Back!",
          text: "Login successful.",
          timer: 2000,
          showConfirmButton: false,
        });
      }

      // continue post-login logic
      if (data.username) setUserName(data.username);
      await fetchUserDocuments(data.access_token);
    }

    // 🚫 DEVICE LIMIT REACHED
    else if (res.status === 403 && data.detail?.includes("Device limit")) {
      setDeviceLimitMessage(data.detail);
      setShowDeviceLimitModal(true);
      Swal.fire({
        icon: "warning",
        title: "Access Restricted",
        text: data.detail,
      });
    }

    // 🚫 OTHER ERRORS
    else {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: data.detail || "Invalid credentials.",
      });
    }
  } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err.message });
  }
};
useEffect(() => {
  if (authToken) {
    axios.get(`${API_BASE_URL}/account-status`, {
      headers: { Authorization: `Bearer ${authToken}` },
    }).then(res => {
      setIsRestricted(!res.data.is_premium && !res.data.trial_status.valid);
    });
  }
}, [authToken]);

const getFilenameFromResponse = (response, documentId, format) => {
  const contentDisposition = response.headers['content-disposition'] ||
                              response.headers['Content-Disposition'];

  console.log("Content-Disposition header:", contentDisposition); // Debug

  if (contentDisposition) {
    // Try multiple patterns to extract filename
    const patterns = [
      /filename\*=UTF-8''([^;]+)/,  // RFC 5987
      /filename="([^"]+)"/,          // Quoted
      /filename=([^;]+)/             // Unquoted
    ];

    for (const pattern of patterns) {
      const match = contentDisposition.match(pattern);
      if (match && match[1]) {
        let filename = decodeURIComponent(match[1].trim());
        console.log("Extracted filename:", filename);
        return filename;
      }
    }
  }

  // Fallback filename if extraction fails
  const ext = format === "excel" ? "xlsx" : format;
  const fallback = `document_${documentId}_EXP.${ext}`;
  console.log("Using fallback filename:", fallback);
  return fallback;
};

  const handleSmartExport = async (fileId, format, fileType = "bank_statement") => {
  try {
    const baseUrl =
      fileType === "invoice"
        ? `https://bank-converter-app-3.onrender.com/export/invoice/${fileId}?format=${format}`
        : `https://bank-converter-app-3.onrender.com/export/${fileId}?format=${format}`;

    const response = await axios.get(baseUrl, {
      headers: { Authorization: `Bearer ${authToken}` },
      responseType: "blob",
    });
    const filename = getFilenameFromResponse(response, fileId, format);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    Swal.fire({
      icon: "success",
      title: "Export Successful",
      text: `${fileType === "invoice" ? "Invoice" : "Transactions"} exported as ${filename}.`,
    });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Export Failed",
      text: "Something went wrong while exporting. Please try again.",
    });
  }
};


  // --- REACTIVE LOGIN SESSION ---
  useEffect(() => {
    if (authToken) {
      fetchUserDocuments(authToken);
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
      setUserDocuments([]);
    }

    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, [authToken]);


const handleChangePassword = async () => {
  const current = prompt("Enter current password:");
  const newPass = prompt("Enter new password:");
  if (!current || !newPass) return;
  try {
    await axios.post(
      "https://bank-converter-app-3.onrender.com/change-password",
      new URLSearchParams({ current_password: current, new_password: newPass }),
      { headers: { Authorization: `Bearer ${token}` } }
    );
    alert("Password changed successfully!");
  } catch (err) {
    alert("Failed to change password: " + err.response?.data?.detail);
  }
};


  const handleLogout = () => {
    Swal.fire({
      icon: "question",
      title: "Logout?",
      text: "Are you sure you want to log out?",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#aaa",
      confirmButtonText: "Yes, logout",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoggedIn(false);
        setAuthToken("");
        localStorage.removeItem("token");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userName");
        setCredentials({ email: "", password: "" });
        setCurrentDocumentId(null);
        setUserEmail("");
        setUserDocuments([]);
        setUploadsHistory([]);
        setExportCount(0);
        setSelectedFileId(null);
        setActiveMenu("dashboard");
        Swal.fire({ icon: "success", title: "Logged out successfully" });
      }
    });
  };
const [uploadMessage, setUploadMessage] = useState(null);
 const handleUploadSuccess = async (result) => {
  if (result.status === 200) {
    if (result.document_type === "invoice") {
      setCurrentDocumentType("invoice");
      setUploadMessage({
      type: "invoice",
      message: `✅ Invoice "${result.invoice_data?.invoice_number || result.file_name}" uploaded successfully!
      Go to Documents → Invoices to view or export your file.`,
    });

  // Clear preview data since we won't render transactions
 // ✅ Refresh invoice list immediately
      await fetchUserInvoices();

    } else {
      setCurrentDocumentType("bank_statement");
      setCurrentDocumentId(result.document_id);
      await fetchUserDocuments();
      setUploadsHistory((prev) => [
        {
          id: result.document_id,
          name: result.file_name || `upload_${prev.length + 1}.pdf`,
          date: new Date().toLocaleString(),
          type: "statement",
        },
        ...prev,
      ]);
    }
  }
};

   // --- EXPORT ---
  const handleExport = async (format) => {
    if (!currentDocumentId) {
      Swal.fire({
        icon: "info",
        title: "No Document Selected",
        text: "Please upload or select a document first.",
      });
      return;
    }
    try {
      const response = await axios.get(
        `https://bank-converter-app-3.onrender.com/export/${currentDocumentId}?format=${format}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );
       const contentDisposition = response.headers['content-disposition'];
    let filename = `transactions.${format === "excel" ? "xlsx" : format}`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename=([^;]+)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes
      }
    }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        icon: "success",
        title: "Export Successful",
        text: `Your file has been exported as ${filename}.`,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Something went wrong while exporting. Please try again.",
      });
    }
  };
const [documentHistory, setDocumentHistory] = useState([]);

const renderMainContent = () => {
    if (!isLoggedIn) {
      return (
        <div className="login-message">
          <h2>Please log in to continue</h2>
          <p>Once logged in, you can upload, view, and export your files.</p>
        </div>
      );
    }

    switch (activeMenu) {
      case "upload":
        return <FileUpload onUploadSuccess={handleUploadSuccess} />;
      case "transactions":
        return <TransactionsTable documentId={selectedFileId} />;
      case "invoice":
        return <InvoicePreview data={invoiceData} />;
      case "consolidate":
       return isLoading ? (
        <p style={{ textAlign: "center", color: "#777" }}>Loading documents...</p>
      ) : (
        <ConsolidateExport
          authToken={authToken}
          documentHistory={documentHistory || []}
        />
      );
      default:
        return <FileUpload onUploadSuccess={handleUploadSuccess} />;
    }
  };

  const [userProfile, setUserProfile] = useState(null);
useEffect(() => {
  const fetchProfile = async () => {
    try {
      const response = await axios.get("https://bank-converter-app-3.onrender.com/profile", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUserProfile(response.data);
    } catch (error) {
      console.error("Failed to load profile:", error);
      setUserProfile(null);
    }
  };

  if (activeSettingsTab === "profile" && token) {
    fetchProfile();
  }
}, [activeSettingsTab, token]);


  // --- FETCH USER DOCUMENTS ---
  const fetchUserDocuments = async (customToken) => {
    const tokenToUse = customToken || authToken || localStorage.getItem("token");
    if (!tokenToUse) return;

    try {
      const response = await axios.get("https://bank-converter-app-3.onrender.com/my-documents", {
        headers: { Authorization: `Bearer ${tokenToUse}` },
      });
      setUserDocuments(response.data);
    } catch (err) {
      console.error("Failed to fetch documents:", err);
    }
  };
  const [userInvoices, setUserInvoices] = useState([]);
const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
const [selectedInvoice, setSelectedInvoice] = useState(null);

// Fetch all invoices
const fetchUserInvoices = async () => {
  try {
    const res = await axios.get("https://bank-converter-app-3.onrender.com/my-invoices", {
      headers: { Authorization: `Bearer ${authToken}` },
    });
    setUserInvoices(res.data);
  } catch (err) {
    console.error("Failed to fetch invoices:", err);
  }
};

// Fetch invoice details
const handleInvoiceSelect = async (invoiceId) => {
  setSelectedInvoiceId(invoiceId);
  if (!invoiceId) {
    setSelectedInvoice(null);
    return;
  }

  try {
    const res = await axios.get(
      `https://bank-converter-app-3.onrender.com/invoices/${invoiceId}`,
      {
        headers: { Authorization: `Bearer ${authToken}` },
      }
    );
    setSelectedInvoice(res.data);
  } catch (err) {
    console.error("Failed to fetch invoice details:", err);
  }
};

// Call on login
useEffect(() => {
  if (authToken) {
    fetchUserDocuments();
    fetchUserInvoices();
    fetchDocumentHistory();
  }
}, [authToken]);

  // --- EXPORT SINGLE FILE ---
  const handleExportFile = async (documentId, format) => {
    try {
      const response = await axios.get(
        `https://bank-converter-app-3.onrender.com/export/${documentId}?format=${format}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );
       const contentDisposition = response.headers['content-disposition'];
    let filename = `transactions.${format === "excel" ? "xlsx" : format}`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename=([^;]+)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes
      }
    }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        icon: "success",
        title: "Export Successful",
        text: `Your file has been exported as ${filename}.`,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Something went wrong while exporting. Please try again.",
      });
    }
  };
  if (isLoading) {
    return (
      <div className="App-loading-screen">
        <div className="App-loading-bar">
          <div className="App-loading-progress" />
        </div>
        <p>Loading Application...</p>
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <div className="Login-container">
        <div className="Floating-icons">
          {[...Array(50)].map((_, i) => (
            <svg
              key={i}
              className={`icon icon-${i + 1}`}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="rgba(255,255,255,0.2)"
            >
              <path d="M12 2L1 7v2h22V7L12 2zm-1 4h2v2h-2V6zm-7 6v8h16v-8H4zm2 2h2v4H6v-4zm4 0h2v4h-2v-4zm4 0h2v4h-2v-4z" />
            </svg>
          ))}
        </div>
        <div className="Login-card">
          {!isSigningUp ? (
            <>
              <h2>Welcome Back</h2>
              <p>Login to access your documents</p>
              <form onSubmit={handleLogin} className="Login-form">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={credentials.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                />
                <button type="submit">Login</button>
              </form>
              {message && <p className="mt-2 text-center">{message}</p>}
              <p className="mt-4 text-center">
                Don't have an account?{" "}
                <button
                  type="button"
                  className="text-blue-600 hover:underline"
                  onClick={() => setIsSigningUp(true)}
                >
                  Sign up
                </button>
              </p>
            </>
          ) : (
            <>
              <h2>Create Account</h2>
              <p>Sign up to start using the app</p>
              <form onSubmit={handleSignup} className="Login-form">
                <input
                  type="text"
                  name="username"
                  placeholder="Username"
                  value={signupCredentials.username}
                  onChange={handleSignupChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={signupCredentials.email}
                  onChange={handleSignupChange}
                  required
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={signupCredentials.password}
                  onChange={handleSignupChange}
                  required
                />
                <button type="submit">Sign Up</button>
              </form>
              {signupMessage && <p className="mt-2 text-center">{signupMessage}</p>}
              <p className="mt-4 text-center">
                Already have an account?{" "}
                <button
                  type="button"
                  className="text-blue-600 hover:underline"
                  onClick={() => setIsSigningUp(false)}
                >
                  Login
                </button>
              </p>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="App-dashboard">
      <aside className={`Side-menu ${sidebarOpen ? "open" : "closed"}`}>
        <h2>🏦 Bank Converter</h2>

        <button
          className="close-btn"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          {sidebarOpen ? "⟨" : "⟩"}
        </button>
         <ul className="sidebar-menu">
          <li
            className={activeMenu === "dashboard" ? "active" : ""}
            onClick={() => setActiveMenu("dashboard")}
          >
            🏠 Dashboard
          </li>

          <li className="dropdown">
            <div
              className="dropdown-header"
              onClick={() =>
                setActiveMenu((prev) => (prev === "documents" ? "" : "documents"))
              }
            >
              📁 Documents ▾
            </div>

            {activeMenu === "documents" && (
              <ul className="submenu">
                <li
                  className={activeMenu === "transactions" ? "active" : ""}
                  onClick={() => setActiveMenu("transactions")}
                >
                  🏦 Transactions
                </li>
                <li
                  className={activeMenu === "invoices" ? "active" : ""}
                  onClick={() => setActiveMenu("invoices")}
                >
                  📄 Invoices
                </li>
              </ul>
            )}
          </li>
          <li
            className={activeMenu === "consolidate" ? "active" : ""}
            onClick={() => setActiveMenu("consolidate")}
          >
           📊 Consolidated Export
          </li>
          <li
            className={activeMenu === "export" ? "active" : ""}
            onClick={() => setActiveMenu("export")}
          >
            ⬇️ Export / Download
          </li>

          <li
            className={activeMenu === "settings" ? "active" : ""}
            onClick={() => setActiveMenu("settings")}
          >
            ⚙️ Settings
          </li>
        </ul>
       <div className="sidebar-bottom">
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
        <div className="sidebar-user">
          <div className="avatar">{getInitial()}</div>
          <span className="username">{getUserDisplayName()}</span>
        </div>
      </aside>

      <main className="Dashboard-main">
        {/* Trial Banner */}
        {isLoggedIn && <TrialBanner />}

        {/* Dashboard */}
       {activeMenu === "dashboard" && (
  <>
    <div className="heading">
      <h1>Bank Statement & Invoice Converter</h1>
    </div>

    <div className="cards-container">
      <div className="card">
        <h3>Total Documents</h3>
        <p>{uploadsHistory.length}</p>
      </div>
      <div className="card">
        <h3>Last Upload</h3>
        <p>
          {uploadsHistory.length > 0
            ? uploadsHistory[0].name
            : "No uploads yet"}
        </p>
      </div>
      <div className="card">
        <h3>Document Type</h3>
        <p>
          {currentDocumentType === "invoice" ? "📄 Invoice" : "🏦 Statement"}
        </p>
      </div>
      <div className="card">
        <h3>Pending Documents</h3>
        <p>
          {uploadsHistory.filter((u) => !u.processed).length || 0}
        </p>
      </div>
    </div>

    <section className="App-section">
      <h2>Quick Upload</h2>
     {isRestricted ? (
      <div className="restriction-overlay" style={{
        background: "#fff5f5",
        border: "1px solid #fca5a5",
        padding: "20px",
        borderRadius: "8px",
        textAlign: "center",
        color: "#b91c1c",
        marginTop: "20px"
      }}>
        <p style={{ fontWeight: "600" }}>🚫 Your account is restricted.</p>
        <p>Your trial has expired. Please upgrade to continue using uploads and exports.</p>
        <button
          onClick={() => window.location.href = '#/settings?tab=billing'}
          style={{
            background: "#ef4444",
            color: "#fff",
            padding: "10px 18px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Upgrade Now
        </button>
      </div>
    ) : (
      <FileUpload onUploadSuccess={handleUploadSuccess} />
    )}

    </section>

    {/* ✅ SHOW INVOICE IF DOCUMENT IS INVOICE */}
  {uploadMessage && (
  <div
    style={{
      marginTop: "16px",
      padding: "12px 16px",
      borderRadius: "8px",
      backgroundColor:
        uploadMessage.type === "invoice" ? "#fef3c7" : "#dcfce7",
      border: "1px solid #e5e7eb",
      color: "#374151",
    }}
  >
    <p style={{ marginBottom: 0 }}>{uploadMessage.message}</p>

    {uploadMessage.type === "invoice" && (
      <div style={{ marginTop: "8px" }}>
        <a
          href="/invoices"
          style={{
            color: "#2563eb",
            fontWeight: "600",
            textDecoration: "underline",
          }}
        >
          Go to Invoices →
        </a>
      </div>
    )}
  </div>
)}


    {/* ✅ SHOW TRANSACTIONS IF DOCUMENT IS BANK STATEMENT */}
    {currentDocumentType === "bank_statement" || !currentDocumentType ? (
      <section className="App-section">
        <h2>Recent Transactions (Preview)</h2>
        {currentDocumentId ? (
          <TransactionsTable documentId={currentDocumentId} preview={true} />
        ) : (
          <p>No transactions yet. Upload a file to see details.</p>
        )}
      </section>
    ) : null}

    <section className="App-section">
      <h2>Reports & Export</h2>
      {currentDocumentType !== "invoice" && (
      <div className="export-buttons">
      <button
        onClick={() =>
          handleSmartExport(
            currentDocumentType === "invoice" ? selectedInvoiceId || currentDocumentId : currentDocumentId,
            "csv",
            currentDocumentType === "invoice" ? "invoice" : "bank_statement"
          )
        }
        disabled={!currentDocumentId && !selectedInvoiceId}
      >
        ⬇ Export CSV
      </button>

      <button
        onClick={() =>
          handleSmartExport(
            currentDocumentType === "invoice" ? selectedInvoiceId || currentDocumentId : currentDocumentId,
            "excel",
            currentDocumentType === "invoice" ? "invoice" : "bank_statement"
          )
        }
        disabled={!currentDocumentId && !selectedInvoiceId}
      >
        ⬇ Export Excel
      </button>

      <button
        onClick={() =>
          handleSmartExport(
            currentDocumentType === "invoice" ? selectedInvoiceId || currentDocumentId : currentDocumentId,
            "pdf",
            currentDocumentType === "invoice" ? "invoice" : "bank_statement"
          )
        }
        disabled={!currentDocumentId && !selectedInvoiceId}
      >
        ⬇ Export PDF
      </button>
    </div>
    )}
    </section>
  </>
)}
        {/* Transactions */}
        {activeMenu === "transactions" && (
          <section className="App-section">
            <h2>View Transactions</h2>
            {uploadsHistory.length >= 0 ? (
              <>
                <div className="file-selector-container">
                  <label htmlFor="fileSelect">Select a document:</label>
                  <div className="custom-select-wrapper">
                    <select
                      id="fileSelect"
                      className="custom-select"
                      value={selectedFileId || ""}
                      onChange={(e) => setSelectedFileId(e.target.value)}
                    >
                      <option value="">-- Choose Uploaded File --</option>
                      {userDocuments.map((file) => (
                        <option key={file.id} value={file.id}>
                          📄 {file.filename} — {new Date(file.upload_date).toLocaleString()}
                        </option>
                      ))}
                    </select>

                  </div>
                </div>

                <div className="transactions-display">
                  {selectedFileId ? (
                    <TransactionsTable documentId={selectedFileId} />
                  ) : (
                    <p className="no-file-text">Select a document to view its transactions.</p>
                  )}
                </div>
              </>
            ) : (
              <p>No uploaded files available.</p>
            )}
          </section>
        )}
        {activeMenu === "consolidate" && (
  <ConsolidateExport
    authToken={authToken}
    documentHistory={documentHistory || []}
  />
)}

   {activeMenu === "invoices" && (
  <section className="App-section">
    <h2>View Invoices</h2>
    {userInvoices.length > 0 ? (
      <>
        <div className="file-selector-container">
          <label htmlFor="invoiceSelect">Select an Invoice:</label>
          <div className="custom-select-wrapper">
            <select
              id="invoiceSelect"
              className="custom-select"
              value={selectedInvoiceId || ""}
              onChange={(e) => handleInvoiceSelect(e.target.value)}
            >
              <option value="">-- Choose Uploaded Invoice --</option>
              {userInvoices.map((inv) => (
            <option key={inv.id} value={inv.id}>
             {inv.filename} ({new Date(inv.upload_date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })})
            </option>
              ))}
            </select>
          </div>
        </div>

        <div className="invoice-display">
          {selectedInvoice ? (
            <InvoicePreview data={selectedInvoice} />
          ) : (
            <p className="no-file-text">Select an invoice to view its preview.</p>
          )}
        </div>
      </>
    ) : (
      <p>No uploaded invoices found.</p>
    )}
  </section>
)}


          {activeMenu === "export" && (
          <section className="App-section">
            <h2>Export & Download Files</h2>

            {/* Bank Statements */}
            {userDocuments.length > 0 && (
              <>
                <h3>🏦 Bank Statements</h3>
                <div className="export-list">
                  {userDocuments.map((file) => (
                    <div key={file.id} className="export-card">
                      <div className="export-info">
                        <h4>{file.filename}</h4>
                        <p>Uploaded: {new Date(file.upload_date).toLocaleString()}</p>
                      </div>
                      <div className="export-actions">
                        <button onClick={() => handleSmartExport(file.id, "csv")}>⬇ CSV</button>
                        <button onClick={() => handleSmartExport(file.id, "excel")}>⬇ Excel</button>
                        <button onClick={() => handleSmartExport(file.id, "pdf")}>⬇ PDF</button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Invoices */}
            {userInvoices.length > 0 && (
              <>
                <h3>📄 Invoices</h3>
                <div className="export-list">
                  {userInvoices.map((inv) => (
                    <div key={inv.id} className="export-card">
                      <div className="export-info">
                        <h4>{inv.filename}</h4>
                        <p>Uploaded: {new Date(inv.upload_date).toLocaleString()}</p>
                      </div>
                      <div className="export-actions">
                        <button onClick={() => handleSmartExport(inv.id, "csv", "invoice")}>⬇ CSV</button>
                        <button onClick={() => handleSmartExport(inv.id, "excel", "invoice")}>⬇ Excel</button>
                        <button onClick={() => handleSmartExport(inv.id, "pdf", "invoice")}>⬇ PDF</button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {userDocuments.length === 0 && userInvoices.length === 0 && (
              <p>No uploaded files found. Upload a document first.</p>
            )}
          </section>
        )}

        {/* Settings */}
        {activeMenu === "settings" && (
          <section className="Settings-page">
            {/* Sub-sidebar inside Settings */}
            <aside className="settings-sub-sidebar">
              <ul>
                <li>
                  <button
                    className={activeSettingsTab === "general" ? "active-tab" : ""}
                    onClick={() => setActiveSettingsTab("general")}
                  >
                     🧩 General
                  </button>
                </li>
                <li>
                  <button
                    className={activeSettingsTab === "profile" ? "active-tab" : ""}
                    onClick={() => setActiveSettingsTab("profile")}
                  >
                    👤 Profile
                  </button>
                </li>
                <li>
                  <button
                    className={activeSettingsTab === "security" ? "active-tab" : ""}
                    onClick={() => setActiveSettingsTab("security")}
                  >
                    🔒 Security
                  </button>
                </li>

                <li>
                  <button
                    className={activeSettingsTab === "billing" ? "active-tab" : ""}
                    onClick={() => setActiveSettingsTab("billing")}
                  >
                     💳 Billing & Premium
                  </button>
                </li>
              </ul>
            </aside>

            {/* Settings main content */}
            <div className="settings-main">
              {/* General */}
              {activeSettingsTab === "general" && (
                <div className="settings-section">
                  <h2>General Settings</h2>
                  <form>
                    <div className="form-group">
                      <label>Company Name</label>
                      <input type="text" />
                    </div>
                    <div className="form-group">
                      <label>Timezone</label>
                      <select>
                        <option>GMT</option>
                        <option>UTC</option>
                        <option>EST</option>
                        <option>PST</option>
                      </select>
                    </div>
                    <button>Save Changes</button>
                  </form>
                </div>
              )}
                {activeSettingsTab === "profile" && (
                  <div className="settings-section">
                    <h2>👤 User Profile</h2>

                    {userProfile ? (
                      <div className="profile-card">
                        <div className="profile-details">
                          <p><strong>Username:</strong> {userProfile.username}</p>
                          <p><strong>Email:</strong> {userProfile.email}</p>
                          <p>
                            <strong>Account Type:</strong>{" "}
                            {userProfile.is_premium ? "🌟 Premium" : "🕓 Free Trial"}
                          </p>

                          {!userProfile.is_premium && (
                            <>
                              <p><strong>Trial Ends:</strong> {new Date(userProfile.trial_end_date).toLocaleDateString()}</p>
                              <p><strong>Days Remaining:</strong> {userProfile.trial_days_remaining} days</p>
                            </>
                          )}

                          {userProfile.subscription_end_date && (
                            <p>
                              <strong>Subscription Ends:</strong>{" "}
                              {new Date(userProfile.subscription_end_date).toLocaleDateString()}
                            </p>
                          )}
                        </div>


                      </div>
                    ) : (
                      <p>Loading profile...</p>
                    )}
                  </div>
                )}



              {/* Security */}
              {activeSettingsTab === "security" && (
                <div className="settings-section">
                  <h2>Security & Active Sessions</h2>

                  {/* Session Manager Component */}
                  <SessionManager />
                    {/* Password Change Form */}
                    <h3 style={{ marginTop: "40px" }}>Change Password</h3>
                    <form
                      onSubmit={async (e) => {
                        e.preventDefault();

                        const currentPassword = e.target.current_password.value;
                        const newPassword = e.target.new_password.value;
                        const confirmPassword = e.target.confirm_password.value;

                        if (newPassword !== confirmPassword) {
                          alert("New passwords do not match");
                          return;
                        }

                        const token = localStorage.getItem("token");
                        const formData = new FormData();
                        formData.append("current_password", currentPassword);
                        formData.append("new_password", newPassword);

                        try {
                          const response = await axios.post(
                            "https://bank-converter-app-3.onrender.com/change-password",
                            formData,
                            { headers: { Authorization: `Bearer ${token}` } }
                          );
                          Swal.fire({
                            icon: "success",
                            title: "Password Changed",
                            text: "Your password was updated successfully.",
                            confirmButtonColor: "#3085d6",
                          });
                          e.target.reset();
                        } catch (err) {
                          Swal.fire({
                            icon: "error",
                            title: "Failed",
                            text: err.response?.data?.detail || "Something went wrong. Try again.",
                          });
                        }
                      }}
                    >
                      <div className="form-group">
                        <label>Current Password</label>
                        <input type="password" name="current_password" required />
                      </div>
                      <div className="form-group">
                        <label>New Password</label>
                        <input type="password" name="new_password" required />
                      </div>
                      <div className="form-group">
                        <label>Confirm New Password</label>
                        <input type="password" name="confirm_password" required />
                      </div>
                      <button type="submit">Update Password</button>
                    </form>

                </div>
              )}


                {/* Billing & Premium */}
                {activeSettingsTab === "billing" && (
                  <div className="settings-section">
                    <h2>Billing & Premium Plans</h2>

                    {/* Current Plan Status */}
                    <div className="current-plan-banner">
                      <div className="plan-info">
                        <h3>Current Plan: <span className="plan-badge">Free Trial</span></h3>
                        <p>Your 7-day trial is active. Upgrade anytime to unlock unlimited features.</p>
                      </div>
                    </div>

                    {/* Pricing Cards */}
                    <div className="pricing-grid">

                      {/* Starter Plan */}
                      <div className="pricing-card">
                        <div className="plan-header">
                          <h3>Starter</h3>
                          <div className="price">
                            <span className="currency">£</span>
                            <span className="amount">15</span>
                            <span className="period">/month</span>
                          </div>
                        </div>
                        <div className="plan-features">
                          <ul>
                            <li>✅ Upload up to 20 documents/month</li>
                            <li>✅ Automated data extraction</li>
                            <li>✅ Smart validation & error detection</li>
                            <li>✅ Export to Excel & CSV</li>
                            <li>✅ Basic reporting</li>
                            <li>✅ Email support</li>
                            <li>❌ AI Categorisation</li>
                            <li>❌ Integrations (Xero, QuickBooks)</li>
                            <li>❌ Multi-user access</li>
                          </ul>
                        </div>
                        <button className="upgrade-btn starter-btn">
                          Select Starter Plan
                        </button>
                      </div>

                      {/* Professional Plan - POPULAR */}
                      <div className="pricing-card popular">
                        <div className="popular-badge">MOST POPULAR</div>
                        <div className="plan-header">
                          <h3>Professional</h3>
                          <div className="price">
                            <span className="currency">£</span>
                            <span className="amount">39</span>
                            <span className="period">/month</span>
                          </div>
                        </div>
                        <div className="plan-features">
                          <ul>
                            <li>✅ <strong>Unlimited uploads</strong></li>
                            <li>✅ Automated data extraction</li>
                            <li>✅ Smart validation & error detection</li>
                            <li>✅ Export to Excel & CSV</li>
                            <li>✅ <strong>AI Categorisation</strong></li>
                            <li>✅ Real-time reporting & analytics</li>
                            <li>✅ Priority email support</li>
                            <li>✅ Up to 2 active devices</li>
                            <li>❌ Integrations (Xero, QuickBooks)</li>
                            <li>❌ Multi-user access</li>
                          </ul>
                        </div>
                        <button className="upgrade-btn professional-btn">
                          Select Professional Plan
                        </button>
                      </div>

                      {/* Enterprise Plan */}
                      <div className="pricing-card">
                        <div className="plan-header">
                          <h3>Enterprise</h3>
                          <div className="price">
                            <span className="currency">£</span>
                            <span className="amount">79</span>
                            <span className="period">/month</span>
                          </div>
                        </div>
                        <div className="plan-features">
                          <ul>
                            <li>✅ <strong>Unlimited uploads</strong></li>
                            <li>✅ Everything in Professional, plus:</li>
                            <li>✅ <strong>Unlimited active devices</strong></li>
                            <li>✅ <strong>Multi-user access</strong></li>
                            <li>✅ <strong>Integrations</strong> (Xero, QuickBooks, Sage)</li>
                            <li>✅ Advanced analytics & insights</li>
                            <li>✅ Audit trails & compliance tools</li>
                            <li>✅ API access</li>
                            <li>✅ 24/7 Priority support</li>
                            <li>✅ Dedicated account manager</li>
                          </ul>
                        </div>
                        <button className="upgrade-btn enterprise-btn">
                          Select Enterprise Plan
                        </button>
                      </div>

                    </div>

                    {/* Feature Comparison Table */}
                    <div className="comparison-table">
                      <h3>Detailed Feature Comparison</h3>
                      <table>
                        <thead>
                          <tr>
                            <th>Feature</th>
                            <th>Starter</th>
                            <th>Professional</th>
                            <th>Enterprise</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Documents per month</td>
                            <td>20</td>
                            <td>Unlimited</td>
                            <td>Unlimited</td>
                          </tr>
                          <tr>
                            <td>Active devices</td>
                            <td>2</td>
                            <td>2</td>
                            <td>Unlimited</td>
                          </tr>
                          <tr>
                            <td>AI Categorisation</td>
                            <td>❌</td>
                            <td>✅</td>
                            <td>✅</td>
                          </tr>
                          <tr>
                            <td>Real-time Reporting</td>
                            <td>Basic</td>
                            <td>Advanced</td>
                            <td>Advanced + Analytics</td>
                          </tr>
                          <tr>
                            <td>Integrations</td>
                            <td>❌</td>
                            <td>❌</td>
                            <td>✅ (Xero, QuickBooks, Sage)</td>
                          </tr>
                          <tr>
                            <td>Multi-user access</td>
                            <td>❌</td>
                            <td>❌</td>
                            <td>✅</td>
                          </tr>
                          <tr>
                            <td>Support</td>
                            <td>Email</td>
                            <td>Priority Email</td>
                            <td>24/7 + Account Manager</td>
                          </tr>
                          <tr>
                            <td>Price</td>
                            <td><strong>£15/mo</strong></td>
                            <td><strong>£39/mo</strong></td>
                            <td><strong>£79/mo</strong></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Payment Methods */}
                    <div className="billing-info">
                      <h3>Payment Methods</h3>
                      <p>We accept all major credit cards and bank transfers.</p>
                      <div className="payment-icons">
                        <span>💳 Visa</span>
                        <span>💳 Mastercard</span>
                        <span>💳 Amex</span>
                        <span>🏦 Bank Transfer</span>
                      </div>
                      <button className="btn-secondary">Add Payment Method</button>

                      <h3 style={{marginTop: "30px"}}>Billing History</h3>
                      <button className="btn-secondary">View Invoices</button>
                    </div>

                    {/* FAQ Section */}
                    <div className="billing-faq">
                      <h3>Frequently Asked Questions</h3>
                      <div className="faq-item">
                        <strong>Can I change plans anytime?</strong>
                        <p>Yes! You can upgrade or downgrade at any time. Changes take effect immediately.</p>
                      </div>
                      <div className="faq-item">
                        <strong>What happens after my trial ends?</strong>
                        <p>Your account will be limited until you select a paid plan. No data will be lost.</p>
                      </div>
                      <div className="faq-item">
                        <strong>Do you offer refunds?</strong>
                        <p>Yes, we offer a 30-day money-back guarantee on all plans.</p>
                      </div>
                      <div className="faq-item">
                        <strong>Is my data secure?</strong>
                        <p>Absolutely. We use bank-level encryption and are fully GDPR-compliant.</p>
                      </div>
                    </div>

                  </div>
                )}
            </div>
          </section>
        )}

        {/* Device Limit Modal */}
        {showDeviceLimitModal && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000
          }}>
            <div style={{
              background: "white",
              padding: "30px",
              borderRadius: "15px",
              textAlign: "center",
              maxWidth: "500px",
              width: "90%",
              boxShadow: "0 10px 40px rgba(0,0,0,0.3)"
            }}>
              <h2 style={{ color: "#f5576c", marginBottom: "20px" }}>⚠️ Access Restricted</h2>
              <p style={{ fontSize: "16px", marginBottom: "30px", color: "#333" }}>
                {deviceLimitMessage}
              </p>
              <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                <button
                  style={{
                    padding: "12px 24px",
                    background: "#667eea",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600"
                  }}
                  onClick={() => {
                    setShowDeviceLimitModal(false);
                    setActiveMenu("settings");
                    setActiveSettingsTab("billing");
                  }}
                >
                  Upgrade to Premium
                </button>
                <button
                  style={{
                    padding: "12px 24px",
                    background: "#e0e0e0",
                    color: "#333",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600"
                  }}
                  onClick={() => setShowDeviceLimitModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default App;